import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarker, faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faFacebook, faTwitter, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { Link } from "react-router-dom";

function Footer() {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDqX25cSrH0ALy5BjJa4y28MQb8Wu6ZOZI",
  });

  if (!isLoaded) return <div className="text-center py-10">Loading Map...</div>;

  return (
    <footer className="bg-black text-white">
      <div className="px-4 2xl:px-0 py-10 max-w-[1280px] mx-auto flex flex-col md:flex-row justify-between gap-10">
        {/* Company Info */}
        <div className="w-full md:w-[30%] flex flex-col">
          <h2 className="text-[#3b86ff] text-lg font-semibold">
            Integrated Holistic Psychotherapy
          </h2>
          <h3 className="text-sm mt-2 md:mt-4">
            Consultancy and Counseling firm offering quality services in a safe, confidential, and supportive environment.
          </h3>

          <div className="flex flex-col gap-2 mt-2 md:mt-4">
            <div className="flex items-center gap-2">
              <FontAwesomeIcon icon={faPhone} />
              <span className="text-sm">+254729569381 | +254784751166</span>
            </div>
            <div className="flex items-center gap-2">
              <FontAwesomeIcon icon={faEnvelope} />
              <a
                href="mailto:ihpsy18@gmail.com"
                className="text-white text-sm hover:underline"
              >
                ihpsy18@gmail.com
              </a>
            </div>
            <div className="flex items-center gap-2">
              <FontAwesomeIcon icon={faMapMarker} />
              <span className="text-sm">Doctors Plaza, Ruiru Ground Floor, Room F06</span>
            </div>
          </div>

          <div className="flex gap-3 mt-2 md:mt-4">
            <FontAwesomeIcon icon={faFacebook} color="#3b86ff" />
            <FontAwesomeIcon icon={faTwitter} color="#3b86ff" />
            <FontAwesomeIcon icon={faYoutube} color="#3b86ff" />
          </div>
        </div>

        {/* Quick Links */}
        <div className="w-full md:w-[25%]">
          <h2 className="text-[#3b86ff] text-lg font-semibold mb-2 md:mb-4">Quick Links</h2>
          <ul className="flex flex-col -gap-2">
            <li><h3>
              <Link to="/about" className="text-sm hover:underline">About Us</Link>
            </h3></li>
            <li>
              <h3>
                <Link to="/resources" className="text-sm hover:underline">Blog | Videos</Link>
              </h3>
            </li>
            <li>
              <h3>
                <Link to="/gallery" className="text-sm hover:underline">Gallery</Link>
              </h3>
            </li>
            <li>
              <h3>
                <Link to="/contact" className="text-sm hover:underline">Contact Us</Link>
              </h3>
            </li>
          </ul>
        </div>


        {/* Location / Map */}
        <div className="w-full md:w-[45%] flex flex-col">
          <h2 className="text-[#3b86ff] text-lg font-semibold mb-2">Location</h2>
          <div className="w-full h-96 rounded-lg overflow-hidden border border-gray-600">
            <GoogleMap
              mapContainerStyle={{ width: "100%", height: "100%" }}
              center={{ lat: -1.146683, lng: 36.95794 }}
              zoom={19}
            >
              <Marker position={{ lat: -1.146683, lng: 36.95794 }} />
            </GoogleMap>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="bg-gray-800 text-center py-4">
        <p className="text-sm">Integrated Holistic Psychotherapy © 2025</p>
      </div>
    </footer>
  );
}

export default Footer;
